import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useLang } from "../i18n/LangContext";
import { api, extractError } from "../api/client";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { AUTH } from "../constants/testIds";

export default function ResetPassword() {
  const { t } = useLang();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pwd, setPwd] = useState("");
  const [error, setError] = useState("");
  const [ok, setOk] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (pwd.length < 8) {
      setError(t("validation.passwordWeak"));
      return;
    }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pwd });
      setOk(true);
    } catch (err) {
      setError(extractError(err).message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="space-y-8">
      <div className="space-y-2">
        <h1 className="font-[Outfit] text-4xl font-extrabold text-white tracking-tight">{t("auth.resetTitle")}</h1>
        <p className="text-slate-400">{t("auth.resetSubtitle")}</p>
      </div>
      {ok ? (
        <>
          <div data-testid={AUTH.resetSuccess} className="rounded-lg border border-emerald-500/30 bg-emerald-500/10 px-4 py-3 text-sm text-emerald-300">
            {t("auth.resetSuccess")}
          </div>
          <Link to="/login" className="text-white font-semibold hover:text-[#FF3B30]">→ {t("auth.loginLink")}</Link>
        </>
      ) : (
        <form onSubmit={submit} className="space-y-5">
          <div className="space-y-2">
            <Label className="text-slate-300">{t("auth.newPassword")}</Label>
            <Input data-testid={AUTH.resetPassword} type="password" required value={pwd} onChange={(e) => setPwd(e.target.value)} className="bg-[#1C202E] border-white/10 text-white h-11" />
          </div>
          {error && <div className="rounded-lg border border-red-500/30 bg-red-500/10 px-4 py-3 text-sm text-red-300">{error}</div>}
          {!token && <div className="text-xs text-amber-400">Missing token</div>}
          <Button data-testid={AUTH.resetSubmit} type="submit" disabled={busy || !token} className="w-full h-11 bg-[#FF3B30] hover:bg-[#E02E24] text-white font-semibold">
            {busy ? t("common.loading") : t("auth.resetSubmit")}
          </Button>
        </form>
      )}
    </div>
  );
}
